/* eslint-disable no-lone-blocks */
import React, { useEffect } from 'react';
import ColorWrapper from '@styles/colors';
import Loading from '@components/loading';

import { setMsalSession } from '@config/msalSession';
import { getSecureValue, navigateTo } from '@helpers';

const SigninOIDC = ({ useMsal, updateTokenState }) => {
  const { instance } = useMsal();
  useEffect(() => {
    (async () => {
      try {
        const r = await instance.handleRedirectPromise();
        if (r) {
          // Successful login redirect — store session and navigate
          setMsalSession(r.account, r.accessToken);
          updateTokenState(r.accessToken);
          navigateTo('Authorized');
        } else {
          // No redirect response — either already processed by index.web.js
          // or user navigated here directly. Check if we have a session.
          const token = getSecureValue('token');
          if (token) {
            updateTokenState(token);
            navigateTo('Authorized');
          } else {
            navigateTo('Login');
          }
        }
      } catch (error) {
        console.error('SigninOIDC redirect error:', error);
        navigateTo('Login');
      }
    })();
  }, []);
  return <Loading />;
};

export default ColorWrapper(SigninOIDC);
